import { useState } from 'react';
import { BookOpen, GraduationCap } from 'lucide-react';
import { LearnVideos } from '../../components/learn/LearnVideos';
import { LearnGuide } from '../../components/learn/LearnGuide';
import { GUIDES, type Guide } from '../../components/learn/guides';

/** Learn (Chris 10/31): the walkthrough video with its chapters, then the
 *  click-through guides that live on the pages themselves. */
export function LiteLearnPage() {
  const [guide, setGuide] = useState<Guide | null>(null);
  const guides = Object.values(GUIDES);
  return (
    <div className="max-w-3xl mx-auto px-4 py-4 space-y-6">
      <div className="flex items-center gap-2">
        <GraduationCap className="w-6 h-6 text-primary-600 dark:text-primary-400" />
        <h1 className="text-2xl font-bold text-slate-900 dark:text-white">
          Learn
        </h1>
      </div>
      <section aria-labelledby="learn-videos-heading" className="space-y-3">
        <h2
          id="learn-videos-heading"
          className="text-sm font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400"
        >
          Videos
        </h2>
        <LearnVideos />
      </section>
      <section aria-labelledby="learn-guides-heading" className="space-y-3">
        <h2
          id="learn-guides-heading"
          className="text-sm font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400"
        >
          Guides
        </h2>
        <ul className="divide-y divide-slate-100 dark:divide-slate-700/60 rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800">
          {guides.map((g) => (
            <li key={g.id}>
              <button
                type="button"
                onClick={() => setGuide(g)}
                className="w-full flex items-center gap-3 px-4 py-3 text-left text-sm text-slate-800 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700/40"
              >
                <BookOpen className="w-4 h-4 text-primary-500" />
                <span className="flex-1">{g.title}</span>
                <span className="text-xs text-slate-500 dark:text-slate-400">
                  {g.steps.length} steps
                </span>
              </button>
            </li>
          ))}
        </ul>
      </section>
      {guide && <LearnGuide guide={guide} onClose={() => setGuide(null)} />}
    </div>
  );
}
